module.exports = __webpack_public_path__ + "static/media/NotoSansCJKjp-Regular.a5a71ded.svg";